import { IFieldValueExtensionSelect } from '../../model';

export const SELECT_YES_NO_DATA: ReadonlyArray<IFieldValueExtensionSelect> = [
  {
    label: '是',
    value: '1',
  },
  {
    label: '否',
    value: '0',
  },
];
